interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    {name: 'footable', src: 'assets/js/footable-init.js'},
    {name: 'footableall', src: 'assets/plugins/footable/js/footable.all.min.js'}
];
